<template>

    <div class="user-lists-modal create-list-dialog">

        <!-- Shadow -->
        <div class="user-lists-modal__shade" @click="closeModal"></div>

        <!-- Modal -->
        <div class="user-lists-modal__inner">

            <!-- Close Modal -->
            <span class="user-lists-modal__close" @click="closeModal">
                <svg class='close'><use xlink:href="#close"></use></svg>
            </span>

            <!-- Title -->
            <h2>Create List</h2>

            <!-- Form -->
            <form :action="`${authUser.username}/lists`" method="post" @submit.prevent="submit">

                <!-- Name -->
                <div class="form__row">
                    <div class="form__row__left">
                        <label for="list-name">Name*</label>
                    </div>
                    <div class="form__row__right">
                        <div class="form__field">
                            <input type="text"
                                   id="list-name"
                                   name="list-name"
                                   placeholder='Like "Favorite Palm Springs Eats" or "Road Trip Planning"'
                                   class="required"
                                   v-model="form.name">
                        </div>
                        <div class="error" v-if="form.errors.name" v-text="form.errors.name"></div>
                    </div>
                </div>

                <!-- Description -->
                <div class="form__row">
                    <div class="form__row__left">
                        <label for="description">Description</label>
                    </div>
                    <div class="form__row__right">
                        <div class="form__field ">
                            <textarea id="description"
                                      rows="5"
                                      v-model="form.description"
                                      name="description"
                                      placeholder="Add some notes">
                            </textarea>
                        </div>
                        <div class="error" v-if="form.errors.description" v-text="form.errors.description"></div>
                    </div>
                </div>

                <!-- Trip Days -->
                <div class="form__row form__date">
                    <div class="form__row__left">
                        <label for="trip_dates">Trip Dates</label>
                    </div>
                    <div class="form__row__right">
                        <div class="form__field">
                            <input type="text"
                                   style="cursor: pointer"
                                   @click="selectDates('open-create-list-dialog')"
                                   placeholder="Add trip dates or days (optional)" readonly :value="inputDateValue">
                            <span class="text-info">Trip dates/days are optional. Only you can see trip dates.</span>
                        </div>
                    </div>
                </div>


                <!-- Secret -->
                <div class="form__row secret-toggle-row">
                    <div class="form__row__left">
                        <label>Secret List</label>
                    </div>
                    <div class="form__row__right">
                        <div class="form__field secret-toggle">
                            <input type="checkbox"
                                   name="secret"
                                   id="secret"
                                   v-model="form.secret" >
                            <div class="switch"><span></span></div>
                            <p style="padding: 0px; width: 60%; margin-left: 20px">
                                If a List is public it automatically gives other users the ability to copy it.
                            </p>
                        </div>
                    </div>
                </div>

                <!-- Submit Button -->
                <div class="form__button">
                    <button type="submit"
                            :class="{ 'is-submitting dis': form.isSubmitted }"
                            :disabled="form.isSubmitted"
                            class="button">
                        {{ form.isSubmitted ? 'Creating' : 'Create List' }}

                        <svg class="arrow-right-2"><use xlink:href="#arrow-right-2"></use></svg>
                    </button>
                </div>

            </form>
        </div>

    </div>

</template>

<script>

import Form from "@/classes/Form"
import Helpers from "@/mixins/Helpers"
import TripDates from "@/mixins/TripDates"
import TripDateSelector from "./TripDateSelector"

export default {

    mixins:[Helpers, TripDates],

    components: {
        TripDateSelector
    },

    data() {
        return {
            form: null,
        }
    },

    created() {
        this.createForm()
        eventBus.$on('open-create-list-dialog', event => {
            this.form.trip_date = event.trip_date
            this.form.trip_days = event.trip_days
            this.openModal()
        });
        eventBus.$on('open-create-list-modal', () => this.openModal());
    },

    mounted() {
        if (window.location.hash == '#create-list') {
            this.openModal()
        }
    },

    methods: {

        submit() {
            this.form.post(`/${this.authUser.username}/lists`)
                .then(response => {
                    eventBus.$emit('list-created', response)
                    this.createForm()
                    this.closeModal()
                })
                .catch(errors => {
                    console.log(errors)
                })
        },

        createForm() {
            this.form = new Form({
                name: '',
                description: '',
                secret: false,
                trip_date: null,
                trip_days: null,
            })
        },

        openModal() {
            $('.create-list-dialog').fadeIn()
            let timeout = setTimeout(() => {
                document.body.classList.add('no-scroll')
                clearTimeout(timeout)
            }, 500)
        },

        closeModal() {
            document.body.classList.remove('no-scroll')
            $('.create-list-dialog').fadeOut();
        },
    }
}
</script>
